module.exports = "../media/link_bg.png";


//////////////////
// WEBPACK FOOTER
// ./img/link_bg.png
// module id = 34
// module chunks = 0